/**
 * BankLogo — Bank-branded circle icon with initial letter
 *
 * Uses Plaid primary_color or fallback from bankBrandColors lookup.
 * Full circle (borderRadius: size/2), white initial letter.
 */

import { getBankColor } from '@/constants/bankBrandColors';

interface BankLogoProps {
  institutionName: string;
  plaidLogo?: string | null;
  plaidColor?: string | null;
  size?: number;
}

export function BankLogo({ institutionName, plaidLogo, plaidColor, size = 30 }: BankLogoProps) {
  if (plaidLogo) {
    return (
      <img
        src={`data:image/png;base64,${plaidLogo}`}
        alt={institutionName}
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
    );
  }

  const color = getBankColor(institutionName, plaidColor);
  const initial = institutionName.charAt(0).toUpperCase();

  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: size / 2,
      background: color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}>
      <span style={{
        fontSize: size * 0.4,
        fontWeight: 700,
        color: '#fff',
        lineHeight: 1,
      }}>
        {initial}
      </span>
    </div>
  );
}
